import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(): boolean {
    // Check if user is authenticated
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return false;
    }

    // Check if user has Admin or SuperAdmin role
    if (!this.authService.hasAdminRole() && !this.authService.hasSuperAdminRole()) {
      this.router.navigate(['/quotes']);
      return false;
    }

    return true;
  }
}

